import React, { useEffect, useState } from "react";
import CompatioLoader from "Components/Common/components/CompatioLoader";
import { getAppletList } from "../ARSServices/ARSServices";
import NoDataComponent from "Components/Common/NoDataComponent";
import closeIcon from "assests/img/close-icon.svg";
import AppletCard from "./AppletCard";


type AppletModalComponentProps = {
    showApplet: boolean;
    closeApplet: () => void;
    channelId: string
};

const AppletModal = ({ showApplet, closeApplet, channelId }: AppletModalComponentProps) => {

    const [appletData, setAppletData] = useState<AppletResponse[] | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const overlayClasses = 'tw-absolute tw-inset-0 tw-z-40 tw-h-full tw-w-full';
    const menuClasses = showApplet
        ? 'tw-absolute tw-top-0 tw-right-0 tw-h-full tw-max-h-full tw-overflow-auto tw-w-full md:tw-w-[550px] tw-bg-white tw-z-50 tw-shadow-lg'
        : 'tw-hidden';

    const fetchAppletData = async () => {
        if (appletData !== null) return;
        setLoading(true);

        try {
            const res = await getAppletList(channelId);

            if (res?.done) {
                setAppletData(res.data);
            }
        } catch (error) {
            console.error(`Error fetching data:`, error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (showApplet) {
            fetchAppletData();
        }
    }, [showApplet, channelId]);

    return (
        <div className="tw-h-[calc(100vh-60px)] tw-fixed tw-top-0 tw-left-0 tw-w-full tw-z-40 tw-mt-16 ">
            <div className={overlayClasses} onClick={closeApplet} />
            <div className={menuClasses}>
                <div
                    className={`tw-flex tw-justify-between tw-items-center  tw-pb-2 tw-pt-4 tw-pr-2 tw-pl-2 tw-sticky tw-top-0 tw-bg-white tw-z-10`}
                >
                    <div className="tw-ml-2 tw-font-bold">
                        Applet
                    </div>
                    <div className="tw-mr-2 tw-cursor-pointer" onClick={closeApplet}>
                        <img
                            className="promotion-close-icon"
                            src={closeIcon}
                            alt="Close icon"
                        />
                    </div>
                </div>

                <div className="tw-p-4">
                    {loading ? (
                        <div className="tw-flex tw-justify-center tw-py-8">
                            <CompatioLoader />
                        </div>
                    ) : appletData && appletData?.length > 0 ? (
                        <div>
                            {appletData?.map((applet) => (
                                <AppletCard key={applet.applet_id} applet={applet} setAppletData={setAppletData} />
                            ))}
                        </div>
                    ) : (
                        <NoDataComponent message={`No Applets found.`} />
                    )}

                </div>
            </div>

        </div>
    );
};

export default AppletModal;
